<template>
  <performer-projects-layout @scroll-bottom="onScrollToBottom">
    <template #default>
      <main-title>Мои задачи</main-title>

      <horizontal-filter>
        <template #default>
          <filter-item hash="#inwork" text="В работе" />
          <filter-item hash="#done" text="Выполненные" />
        </template>
        <template #right>
          <label class="panel__total-requests">
            Всего: {{ totalCheckpoints }}
          </label>
        </template>
      </horizontal-filter>

      <template v-if="0 === checkpoints.length">
        <p>Нет задач.</p>
      </template>
      <template v-else>
        <check-points-grid :check-points="checkpoints" @update="onUpdate" />
      </template>
    </template>
  </performer-projects-layout>
</template>

<script setup>
  /**
   * Термин "задача", который используется в заголовке компонента,
   * имеет смысл только для Исполнителя.
   * На самом деле под капотом ему отображаются контрольные точки.
   */
  import { onMounted, ref, watch } from 'vue';
  import { useApi } from '@/api/use-api';
  import PerformerProjectsLayout from './layouts/PerformerProjectsLayout.vue';
  import MainTitle from '@/components/titles/MainTitle';
  import HorizontalFilter from '@/components/filter/horizontal/HorizontalFilter';
  import FilterItem from '@/components/filter/components/FilterItem';
  import CheckPointsGrid from '@/views/performer/components/CheckPointsGrid.vue';
  import { useRoute } from 'vue-router';

  const api = useApi();
  const route = useRoute();
  const checkpoints = ref([]);
  const totalCheckpoints = ref(0);

  const PAGE_SIZE = 20;
  const totalPages = ref(0);
  const lastPage = ref(0);
  const currentPage = ref(1);

  onMounted(async () => {
    await getCheckpoints();
  });

  watch(
    () => route.hash,
    async () => {
      resetState();
      await getCheckpoints();
    }
  );

  const resetState = () => {
    checkpoints.value = [];
    totalCheckpoints.value = 0;
    totalPages.value = 0;
    lastPage.value = 0;
    currentPage.value = 1;
  };

  const onScrollToBottom = async () => {
    if (totalPages.value === 0 || currentPage.value < totalPages.value) {
      currentPage.value++;
      await getCheckpoints();
    }
  };

  const getCheckpoints = async () => {
    try {
      const tab = route.hash ? route.hash.replace('#', '') : 'inwork';
      const response = await api.performerPage.checkpoints(
        new URLSearchParams({
          tab: tab,
          'per-page': PAGE_SIZE,
          page: currentPage.value,
        })
      );
      totalCheckpoints.value = response.checkpoints.total;
      totalPages.value = response.checkpoints.pages.total;
      if (lastPage.value !== currentPage.value) {
        checkpoints.value = checkpoints.value.concat(
          response.checkpoints.items
        );
        lastPage.value = currentPage.value;
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  const onUpdate = async () => {
    resetState();
    await getCheckpoints();
  };
</script>

<style lang="scss" scoped></style>
